var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.page < _vm.pages)?_c('div',{staticClass:"page"},[_vm._v(" 加载更多 ")]):_c('div',{staticStyle:{"text-align":"center","color":"var(--text-color)"}},[_vm._v(" 我也是有底线的-- ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }